export const WsHubMessage = {
    InboxMessageCreated: 'inbox-message-created',
    InboxChannelStatus: 'inbox-channel-status',
    InboxMessageStatus: 'inbox-message-status',
    InboxConversationStatus: 'inbox-conversation-status',
    InboxConversationUpdated: 'inbox-conversation-updated',
    InboxChannelTeamChanged: 'inbox-channel-team-changed',
    InboxTagsUpdated: 'inbox-tags-updated',
    Notification: 'notification',
    ChannelStatus: id => `Status_${id}`,
    QrCode: id => `QrCode_${id}`,
    TypingStatus: 'typing-status',
    ExportStatus: 'export-status',
};
